import api from "../seller-apis/api";

// l1-2341 (9-9-25)
export const saveVendorStock = async (data) => {
    try {                                            //Category condition removed due to issue in | Ticket : SL-1068 and category is not coming In Restock API due API optimization
        if(!data?.product || data?.product === null /*|| !data?.categories || data?.categories?.length === 0*/) {
            throw new Error("Product or categories missing.");
        }
        const res = await api.seller.saveVendorStockStatus(data);
        return true;
    } catch (err) {
        console.log(err)
        throw err;
    }
}